// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1386":"1ba2b979b25ad9ce","2888":"396126a6c3c12850","8189":"1ba2b979b25ad9ce"}[chunkId] + ".css";
};